export const LANGUAGES = [
  { code: "id", label: "ID", name: "Bahasa Indonesia" },
  { code: "en", label: "EN", name: "English" },
  { code: "zh", label: "中文", name: "Chinese" },
];

export const CONTENT = {
  id: {
    meta: {
      companyName: "PT Huatong Trading Indonesia",
      tagline: "Solusi Filler Masterbatch Tepercaya untuk Industri Plastik Modern",
    },
    hero: {
      title: "Filler Masterbatch CaCO₃ & Na₂SO₄ untuk Efisiensi Biaya Tanpa Kompromi Kualitas",
      subtitle:
        "Kami membantu produsen plastik meningkatkan efisiensi formulasi, stabilitas proses, dan kekuatan produk dengan filler masterbatch berkualitas konsisten.",
      bullets: [
        "Formulasi khusus untuk aplikasi film, injection, dan blow molding",
        "Stabilitas proses tinggi, dispersi partikel sangat baik",
        "Dukungan teknis lokal & pengujian laboratorium aplikasi",
      ],
      primaryCta: "Konsultasi Teknis",
      secondaryCta: "Unduh Profil Produk",
    },
    solutions: {
      title: "Solusi Filler Masterbatch",
      intro:
        "Portofolio filler masterbatch CaCO₃ dan Na₂SO₄ yang dirancang untuk membantu pabrik plastik menurunkan biaya bahan baku tanpa mengorbankan performa dan stabilitas proses.",
      items: [
        {
          key: "caco3",
          title: "Filler Masterbatch Calcium Carbonate (CaCO₃)",
          description:
            "Dirancang untuk menggantikan sebagian resin murni, menurunkan biaya material sambil menjaga kekuatan tarik, elongasi, dan kejernihan sesuai kebutuhan aplikasi.",
          bullets: [
            "Kandungan CaCO₃ tinggi dengan distribusi ukuran partikel terkontrol",
            "Kompatibilitas optimal dengan PE, PP, dan campuran tertentu",
            "Pilihan carrier resin dan tingkat whiteness sesuai kebutuhan",
          ],
        },
        {
          key: "na2so4",
          title: "Filler Masterbatch Sodium Sulfate (Na₂SO₄)",
          description:
            "Solusi alternatif untuk aplikasi tertentu yang membutuhkan keseimbangan antara kekakuan, ketahanan panas, dan biaya yang kompetitif.",
          bullets: [
            "Stabilitas termal baik untuk proses dengan suhu lebih tinggi",
            "Membantu kontrol shrinkage dan sifat dimensional",
            "Pilihan formulasi untuk aplikasi film dan molded parts",
          ],
        },
        {
          key: "custom",
          title: "Formulasi Khusus & Co-development",
          description:
            "Tim teknis kami mendampingi Anda mengembangkan grade filler masterbatch spesifik proses, peralatan, dan target biaya perusahaan Anda.",
          bullets: [
            "Optimasi loading level terhadap sifat mekanik",
            "Simulasi performa di lab internal",
            "Pendampingan trial di mesin produksi",
          ],
        },
      ],
    },
    applications: {
      title: "Aplikasi Utama",
      intro:
        "Mendukung berbagai lini produksi plastik mulai dari film & packaging hingga injection dan blow molding untuk kemasan industri dan kebutuhan rumah tangga.",
      categories: [
        {
          key: "film",
          label: "Film & Packaging",
          description:
            "Untuk aplikasi blown dan cast film – kantong belanja, kemasan laundry, stretch film, dan lain-lain.",
          benefits: [
            "Permukaan halus dengan gloss terkontrol",
            "Kemudahan proses dengan stabilitas gelembung yang baik",
            "Potensi pengurangan resin virgin hingga 20–40%*",
          ],
        },
        {
          key: "injection",
          label: "Injection Molding",
          description:
            "Untuk komponen plastik rumah tangga, otomotif, dan industrial parts dengan kebutuhan dimensi presisi.",
          benefits: [
            "Flowability terjaga pada loading filler tinggi",
            "Kontrol shrinkage dan warpage yang lebih baik",
            "Cocok untuk bagian tipis maupun tebal",
          ],
        },
        {
          key: "blow",
          label: "Blow Molding",
          description:
            "Untuk jerigen, botol, dan kontainer berongga yang membutuhkan ketahanan impact dan konsistensi dinding.",
          benefits: [
            "Distribusi ketebalan dinding yang stabil",
            "Peningkatan kekakuan tanpa mengorbankan impact berlebihan",
            "Pengurangan biaya total per unit kemasan",
          ],
        },
      ],
    },
    tech: {
      title: "Keunggulan Teknis",
      intro:
        "Menggabungkan pemilihan bahan baku mineral yang tepat dengan teknologi compounding modern untuk performa yang konsisten di setiap batch produksi.",
      items: [
        {
          title: "Kontrol Kualitas Partikel",
          body: "Distribusi ukuran partikel CaCO₃ dan Na₂SO₄ yang sempit untuk meminimalkan titik lemah pada produk akhir.",
        },
        {
          title: "Dispersi Tingkat Lanjut",
          body: "Menggunakan aditif dispersant dan proses compounding yang dioptimasi agar filler terdistribusi merata dalam matriks polimer.",
        },
        {
          title: "Stabilitas Proses",
          body: "Formulasi yang membantu menjaga tekanan extruder dan temperatur melt lebih stabil selama produksi.",
        },
        {
          title: "Dukungan Aplikatif",
          body: "Tim technical service siap membantu analisa material, rekomendasi setting mesin, hingga pendampingan trial di pabrik Anda.",
        },
      ],
    },
    faq: {
      title: "Pertanyaan yang Sering Diajukan",
      items: [
        {
          question: "Berapa persentase loading filler yang direkomendasikan?",
          answer:
            "Umumnya antara 5–40% tergantung jenis aplikasi, target sifat mekanik, dan spesifikasi produk akhir. Tim kami akan membantu menentukan formulasi optimal.",
        },
        {
          question: "Apakah penggunaan CaCO₃ akan menurunkan kekuatan tarik film?",
          answer:
            "Dengan pemilihan ukuran partikel dan level loading yang tepat, penurunan sifat mekanik dapat dikontrol sehingga tetap memenuhi standar aplikasi.",
        },
        {
          question: "Apakah tersedia sampel untuk uji coba?",
          answer:
            "Ya, kami dapat menyediakan sampel skala lab maupun pre-production, serta rekomendasi parameter proses untuk uji coba di mesin Anda.",
        },
      ],
    },
    cta: {
      title: "Diskusikan Kebutuhan Filler Masterbatch Anda",
      subtitle:
        "Kirimkan detail aplikasi dan tantangan produksi Anda. Tim kami akan menghubungi Anda dengan rekomendasi formulasi dan estimasi potensi penghematan biaya.",
      form: {
        name: "Nama Lengkap",
        company: "Perusahaan",
        email: "Email Kerja",
        application: "Jenis Aplikasi",
        message: "Tantangan proses atau spesifikasi yang ingin dicapai",
        submit: "Kirim Permintaan Konsultasi",
      },
      toastSuccessTitle: "Permintaan terkirim",
      toastSuccessBody:
        "Tim kami akan menghubungi Anda dalam 1–2 hari kerja melalui email atau WhatsApp yang tercantum.",
    },
  },
  en: {
    meta: {
      companyName: "PT Huatong Trading Indonesia",
      tagline: "Trusted Filler Masterbatch Solutions for Modern Plastics Manufacturing",
    },
    hero: {
      title: "CaCO₃ & Na₂SO₄ Filler Masterbatch for Cost Efficiency Without Quality Compromise",
      subtitle:
        "We help plastic manufacturers optimize formulation cost, process stability, and mechanical performance with consistently engineered filler masterbatch.",
      bullets: [
        "Grades tailored for film, injection, and blow molding applications",
        "Excellent particle dispersion and process stability",
        "Local technical support and application testing lab",
      ],
      primaryCta: "Talk to a Specialist",
      secondaryCta: "Download Product Profile",
    },
    solutions: {
      title: "Filler Masterbatch Solutions",
      intro:
        "A portfolio of CaCO₃ and Na₂SO₄ filler masterbatch designed to help converters reduce raw material cost while maintaining consistent process stability and mechanical performance.",
      items: [
        {
          key: "caco3",
          title: "Calcium Carbonate (CaCO₃) Filler Masterbatch",
          description:
            "Designed to partially replace virgin resin and reduce material cost while maintaining required tensile strength, elongation, and clarity.",
          bullets: [
            "High CaCO₃ loading with controlled particle size distribution",
            "Optimized compatibility with PE, PP, and selected blends",
            "Multiple carrier resin and whiteness options",
          ],
        },
        {
          key: "na2so4",
          title: "Sodium Sulfate (Na₂SO₄) Filler Masterbatch",
          description:
            "Alternative solution for applications requiring a balance of stiffness, heat resistance, and competitive total cost.",
          bullets: [
            "Good thermal stability for higher processing temperatures",
            "Helps control shrinkage and dimensional stability",
            "Available grades for film and molded parts",
          ],
        },
        {
          key: "custom",
          title: "Custom Formulation & Co-development",
          description:
            "Our technical team co-develops dedicated grades tuned to your process, equipment, and cost targets.",
          bullets: [
            "Optimization of filler loading versus mechanical properties",
            "Application simulation and internal lab testing",
            "On-site support during production trials",
          ],
        },
      ],
    },
    applications: {
      title: "Key Applications",
      intro:
        "Supporting a wide range of plastic production lines from packaging film to injection and blow molding for industrial and consumer products.",
      categories: [
        {
          key: "film",
          label: "Film & Packaging",
          description:
            "For blown and cast film – shopping bags, detergent packaging, liners, and more.",
          benefits: [
            "Smooth surface with controlled gloss level",
            "Stable bubble formation during film extrusion",
            "Potential resin savings up to 20–40%*",
          ],
        },
        {
          key: "injection",
          label: "Injection Molding",
          description:
            "For household, automotive, and industrial parts requiring dimensional accuracy.",
          benefits: [
            "Maintained flow at higher filler loading",
            "Improved shrinkage and warpage control",
            "Suitable for both thin and thick wall parts",
          ],
        },
        {
          key: "blow",
          label: "Blow Molding",
          description:
            "For jerry cans, bottles, and hollow containers requiring impact strength and wall consistency.",
          benefits: [
            "Stable wall thickness distribution",
            "Enhanced stiffness without excessive brittleness",
            "Lower total packaging cost per unit",
          ],
        },
      ],
    },
    tech: {
      title: "Technical Advantages",
      intro:
        "Combining carefully selected mineral sources with modern compounding technology to deliver consistent, repeatable performance in every batch.",
      items: [
        {
          title: "Controlled Particle Quality",
          body: "Narrow particle size distribution of CaCO₃ and Na₂SO₄ to minimize weak points in the final product.",
        },
        {
          title: "Advanced Dispersion",
          body: "Use of dedicated dispersants and optimized compounding to ensure uniform filler distribution.",
        },
        {
          title: "Process Stability",
          body: "Formulations designed to keep extruder pressure and melt temperature stable during long runs.",
        },
        {
          title: "Application Support",
          body: "Our technical service team supports material analysis, machine setting recommendations, and on-site trials.",
        },
      ],
    },
    faq: {
      title: "Frequently Asked Questions",
      items: [
        {
          question: "What is the recommended filler loading level?",
          answer:
            "Typically 5–40% depending on application, target properties, and product requirements. We will help define the optimum formulation.",
        },
        {
          question: "Will CaCO₃ reduce film mechanical strength?",
          answer:
            "With the right particle size and loading level, mechanical property drop can be controlled while still meeting application standards.",
        },
        {
          question: "Can you provide samples for trials?",
          answer:
            "Yes, we provide lab and pre-production scale samples together with recommended processing parameters.",
        },
      ],
    },
    cta: {
      title: "Share Your Filler Masterbatch Requirements",
      subtitle:
        "Share your application details and current challenges. Our team will respond with formulation recommendations and an estimate of potential cost savings.",
      form: {
        name: "Full Name",
        company: "Company",
        email: "Business Email",
        application: "Application Type",
        message: "Process challenges or target specifications",
        submit: "Submit Consultation Request",
      },
      toastSuccessTitle: "Request received",
      toastSuccessBody:
        "Our team will contact you within 1–2 business days via the email or phone number provided.",
    },
  },
  zh: {
    meta: {
      companyName: "印尼华通贸易有限公司 (PT Huatong Trading Indonesia)",
      tagline: "面向现代塑料工业的专业填充母粒解决方案",
    },
    hero: {
      title: "CaCO₃ 与 Na₂SO₄ 填充母粒，降低成本并保持稳定品质",
      subtitle:
        "我们为塑料制品厂提供稳定质量的填充母粒，帮助优化配方成本、生产稳定性和最终制品性能。",
      bullets: [
        "针对薄膜、注塑、吹塑等不同工艺开发专用牌号",
        "优异的颗粒分散性和加工稳定性",
        "本地技术服务与应用实验室支持",
      ],
      primaryCta: "联系技术团队",
      secondaryCta: "下载产品手册",
    },
    solutions: {
      title: "填充母粒解决方案",
      intro:
        "基于 CaCO₃ 与 Na₂SO₄ 的填充母粒组合，为塑料制品厂在保障稳定加工与成品性能的前提下，实现原料成本优化。",
      items: [
        {
          key: "caco3",
          title: "碳酸钙 (CaCO₃) 填充母粒",
          description:
            "通过部分替代原生树脂，在控制拉伸强度、延伸率和外观的前提下，实现材料成本优化。",
          bullets: [
            "高含量 CaCO₃，粒径分布严格控制",
            "与 PE、PP 及部分共混体系具有良好相容性",
            "可提供不同白度和载体树脂选择",
          ],
        },
        {
          key: "na2so4",
          title: "硫酸钠 (Na₂SO₄) 填充母粒",
          description:
            "适用于对刚性、耐热性与成本有综合要求的特定应用。",
          bullets: [
            "适合较高加工温度的热稳定性",
            "有助于控制收缩率和尺寸稳定性",
            "可用于薄膜及注塑制品等应用",
          ],
        },
        {
          key: "custom",
          title: "定制配方与联合开发",
          description:
            "技术团队可根据您的设备条件和成本目标，共同开发专用填充母粒牌号。",
          bullets: [
            "在填充量与力学性能之间寻找最佳平衡",
            "内部实验室进行应用模拟与测试",
            "为现场试机提供技术支持",
          ],
        },
      ],
    },
    applications: {
      title: "主要应用领域",
      intro:
        "覆盖从薄膜包装到注塑与中空吹塑等多种加工工艺，适用于日用、工业及包装等不同终端应用。",
      categories: [
        {
          key: "film",
          label: "薄膜与包装",
          description:
            "适用于吹膜、流延膜，如购物袋、洗涤用品包装、内衬膜等。",
          benefits: [
            "表面光滑，光泽度可控",
            "吹膜气泡稳定性好，易于控制",
            "有机会节省 20–40%* 原生树脂用量",
          ],
        },
        {
          key: "injection",
          label: "注塑制品",
          description:
            "适用于家电、汽车及工业注塑件，对尺寸精度有较高要求。",
          benefits: [
            "在较高填充量下仍保持良好流动性",
            "改善收缩与翘曲控制",
            "适合薄壁与厚壁制品",
          ],
        },
        {
          key: "blow",
          label: "中空吹塑",
          description:
            "适用于桶、瓶和各类中空容器，对抗冲击和壁厚均匀性有要求。",
          benefits: [
            "壁厚分布稳定，制品一致性好",
            "提高刚性，同时避免过度脆化",
            "帮助降低单件包装总成本",
          ],
        },
      ],
    },
    tech: {
      title: "技术优势",
      intro:
        "精选矿物原料结合稳定的熔融共混工艺，为客户提供批次间波动小、易于控制的填充母粒解决方案。",
      items: [
        {
          title: "颗粒品质控制",
          body: "CaCO₃ 与 Na₂SO₄ 采用严格控制的粒径分布，减少制品中的潜在薄弱点。",
        },
        {
          title: "高效分散体系",
          body: "通过专用分散助剂与优化的熔融共混工艺，实现均匀分散。",
        },
        {
          title: "稳定加工窗口",
          body: "配方设计有助于保持挤出压力和熔体温度的稳定，适合长时间连续生产。",
        },
        {
          title: "完善应用支持",
          body: "提供材料分析、工艺参数建议以及现场试机服务。",
        },
      ],
    },
    faq: {
      title: "常见问题",
      items: [
        {
          question: "推荐的填充比例是多少？",
          answer:
            "一般建议 5–40%，视应用类型、性能要求和产品设计而定，我们会根据您的情况给出具体建议。",
        },
        {
          question: "使用 CaCO₃ 是否会明显降低薄膜强度？",
          answer:
            "在选择合适粒径并控制合理填充量的前提下，力学性能下降可以被有效控制，并满足终端使用要求。",
        },
        {
          question: "是否可以提供试样？",
          answer:
            "可以，我们可提供实验室或小试样品，并附加工艺建议供您线上试机。",
        },
      ],
    },
    cta: {
      title: "告诉我们您的填充母粒需求",
      subtitle:
        "请简要说明您的应用场景及当前面临的挑战，我们将为您提供配方建议及潜在成本优化方案。",
      form: {
        name: "姓名",
        company: "公司名称",
        email: "工作邮箱",
        application: "应用类型",
        message: "目前的工艺难点或目标性能要求",
        submit: "提交咨询请求",
      },
      toastSuccessTitle: "已收到您的信息",
      toastSuccessBody: "我们将在 1–2 个工作日内通过您提供的邮箱或联系方式与您取得联系。",
    },
  },
};
